import { Cancel, Close, Save } from '@mui/icons-material';
import { Button, DialogContent, IconButton, Paper } from '@mui/material';
import { AppBar, Dialog, Stack, Toolbar, useMediaQuery, useTheme } from '@mui/material'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { grey } from '@mui/material/colors';
import SystemAnnouncementModal from './SystemAnnouncementModal';
import EllipsisTypography from '../../../components/EllipsisTypography';
import TechInfo from '../../../components/TechInfo';
import TabNavigation from '../../../components/TabNavigation';
import { history } from '../../../_helpers';

const EditSystemAnnouncementDialog = ({ isOpenEditIconDialog, onClose, systemAnnouncementData,onSuccess , updateSystemAnnouncementDetails}) => {
    const theme = useTheme()
    const isMobileOrTab = useMediaQuery(theme.breakpoints.down('md'));
    const { t } = useTranslation()
    const [values, setValues] = useState(systemAnnouncementData)
    const [tabValue, setTabValue] = useState(["systemAnnouncement"].includes(isOpenEditIconDialog?.tabId) ? 0 : 1);
    const [errors, setErrors] = useState({})

    const tabs = [
        { title: t("general.general") },
        { title: t("general.techInfo") },
    ];

    const clearError = (key) => {
        setErrors(prev => ({
            ...prev,
            [key]: null
        }));
    };
    
    const validateDetails = () => {
        const newErrors = {};
        const { startDate, endDate,desc} = values || {};
        
        if (!desc?.trim()) {
            newErrors.desc = t("general.field.error");
        }
        if (!startDate) {
            newErrors.startDate = t("general.field.error");
        }
        if (!endDate) {
            newErrors.endDate = t("general.field.error");
        }
         if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            newErrors.startDate = newErrors.endDate = t("general.field.error");
        }
        setErrors(newErrors);

        return {
            isValid: Object.keys(newErrors).length === 0,
            errors: newErrors,
        };
    };

    const handleChange = ({ keyName, value }) => {
        setValues(prev => ({
            ...prev,
            [keyName]: value
        }));

        if (errors[keyName]) {
            clearError(keyName);
        }
    };

    const handleTabChange = (_, newValue) => {
        setTabValue(newValue)
        history.push(tabs[newValue]?.to)
    };
   

  const handleSave = useCallback(() => {
    const validateFields = validateDetails();

    if (validateFields.isValid && Object.keys(validateFields.errors).length === 0) {

        const diff = [];

        Object.keys(values || {}).forEach((keyName) => {
            switch (keyName) {
                case "isBuyerGuidance":
                case "isAftercare":
                case "active":
                    if (values?.[keyName] !== systemAnnouncementData?.[keyName]) {
                        diff.push({
                            id: keyName,
                            name: values?.[keyName]?.toString()
                        });
                    }
                    break;
                default:
                    if (values?.[keyName] !== systemAnnouncementData?.[keyName]) {
                        diff.push({
                            id: keyName,
                            name: values?.[keyName]
                        });
                    }
                    break;
            }
        });
        if (diff.length > 0) {
            updateSystemAnnouncementDetails(diff);
        }

        onClose();
    } else {
        if (["desc", "startDate", "endDate"].includes(
            Object.keys(validateFields.errors)?.[0]
        )) {
            setTabValue(0);
        }
    }
}, [values, systemAnnouncementData]);


    return (
        <>
            <Dialog
                open={isOpenEditIconDialog.open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose();
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        maxWidth: "none",
                        width: 1200,
                        height: { md: 650 }
                    }
                }}
                fullScreen={isMobileOrTab} >
                <AppBar position='relative' sx={{ boxShadow: 'none' }} >
                    <Toolbar >
                        <Stack direction={"row"} width={"100%"} alignItems={"center"} justifyContent={"space-between"}>
                            <Stack direction={"row"} alignItems={"center"}>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={() => onClose()}
                                    aria-label="close"
                                >
                                    <Close />
                                </IconButton>
                                <EllipsisTypography variant={"h6"} sx={{ ml: 2 }} component="div" title={t('systemAnnouncement.title')} />
                            </Stack>
                            <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                <Button onClick={() => onClose()} size='small' sx={{ display: { xs: 'none', sm: "inline-flex" } }} variant="text" color='inherit' startIcon={<Cancel />} >
                                    {t("general.cancel")}
                                </Button>
                                <IconButton onClick={() => onClose()} sx={{ display: { sm: "none" } }} color='inherit'  >
                                    <Cancel />
                                </IconButton>
                                <Button onClick={handleSave} sx={{ display: { xs: 'none', sm: "inline-flex" } }} size='small' variant="text" color='inherit' startIcon={<Save />}>
                                    {t("general.save")}
                                </Button>
                                <IconButton onClick={handleSave} sx={{ display: { sm: "none" } }} color='inherit'  >
                                    <Save />
                                </IconButton>
                            </Stack>
                        </Stack>
                    </Toolbar>
                </AppBar>
                <TabNavigation tabs={tabs} activeTab={tabValue} handleTabChange={handleTabChange} />
                <DialogContent sx={{ bgcolor: grey[100], mt: 0.3, p: 2 }}>
                    <Paper sx={{ width: "100%", bgcolor: "common.white" }} elevation={0}>
                        {tabValue === 0 && <SystemAnnouncementModal values={values} errors={errors} handleChange={handleChange} />}
                        {tabValue === 1 && <TechInfo title={t('general.techInfo')} subtitle={t("general.mutationHistory")} data={values} />}
                    </Paper>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default EditSystemAnnouncementDialog
